import { CURRENT_DEBUG_DEFAULTS_VERSION, migrateDebugDefaults } from './migrate.ts';
import type { DebugDefaultsDocument } from './types.ts';

export function serializeDebugDefaults(document: DebugDefaultsDocument): string {
  return `${JSON.stringify({ ...document, version: CURRENT_DEBUG_DEFAULTS_VERSION }, null, 2)}\n`;
}

export function parseDebugDefaults(json: string): DebugDefaultsDocument | null {
  let parsed: unknown;

  try {
    parsed = JSON.parse(json);
  } catch {
    return null;
  }

  return migrateDebugDefaults(parsed);
}

export function isDebugDefaultsDocument(value: unknown): boolean {
  return migrateDebugDefaults(value) !== null;
}
